import React, { PropTypes } from 'react'
import { Translate, Form, utils, components } from 'unity-core'
const { InputField, FormWrapper, validators } = Form
import { ButtonToolbar } from 'react-bootstrap'
const { fetchClient } = utils
const { AsyncLogger } = components

const Forgot = (props) => {
    const { strings, hide, processing, logReq, renderAlert } = props
    const sendEmail = (email) => {
        logReq('resetpassword', fetchClient.UauthRequest({ endpoint: `unityusers/resetpassword/${email}`, method: 'POST', requiresAuthToken: false }), strings.ForgotPassword.RequestSent, (rst, log) => {
            if (!rst.isErr && !rst.Result)
                log(strings.ForgotPassword.InvalidEmail, true)
        })
    }
    const validate = values => {
        const errors = {}
        if (!values.email) {
            errors.email = strings.Form.Validations.Required
        } else if (!validators.validateEmail(values.email)) {
            errors.email = strings.Form.Validations.InvalidEmail
        }
        return errors
    }
    return (
        <div className="container-fulid" >
            <FormWrapper formName="forgot_pwd"
                validate={validate}
                onSubmit={(values, init) => { init(); sendEmail(values.email) }}
                render={(handleSubmit, valid) => (
                    <form onSubmit={handleSubmit}>
                        <InputField name={'email'} title={strings.ForgotPassword.email} />
                        {renderAlert()}
                        <div className="row">
                            <ButtonToolbar className="pull-right slide-right-10">
                                <button type="submit" className="btn btn-primary" disabled={!valid || processing}>{processing ? strings.ForgotPassword.Processing : strings.ForgotPassword.Send}</button>
                                <button type="button" className="btn btn-default" onClick={() => hide()}>{strings.ForgotPassword.Close}</button>
                            </ButtonToolbar >
                        </div>
                    </form>
                )} />
        </div >
    )
}

const decorators = _.flow([
    Translate('ForgotPassword', 'Form'),
    AsyncLogger('ForgotPassword')
])

export default decorators(Forgot)